import React from 'react';
import { Box } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles<Partial<PercentageDiffCircleProps>>()(theme => ({
  root: {
    lineHeight: '40px',
    width: '40px',
    height: '40px',
    textAlign: 'center',
    borderRadius: '50%',
    fontSize: '13px',
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.common.black,
  },

  colorZero: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.common.white,
  },
  colorNegative: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.darkText,
  },
  colorPositive: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.common.white,
  },
}));


export type PercentageDiffCircleProps = {
  percentage: number;
  classes?: Partial<ReturnType<typeof useStyles>>;
};


export const PercentageDiffCircle: React.FC<PercentageDiffCircleProps> = ({ percentage, ...props }) => {
  const { classes, cx } = useStyles(props, { props });

  if (percentage === 0) {
    return (
      <Box className={cx(classes.root, classes.colorZero)}>±{percentage}%
      </Box>
    );
  }

  if (percentage < 0) {
    return (
      <Box className={cx(classes.root, classes.colorNegative)}>
        {percentage}%
      </Box>
    );
  }

  return (
    <Box className={cx(classes.root, classes.colorPositive)}>+{percentage}%
    </Box>
  );
};
